import script from "./NeedPasswordChangeModal.vue?vue&type=script&setup=true&lang=js"
export * from "./NeedPasswordChangeModal.vue?vue&type=script&setup=true&lang=js"

import "./NeedPasswordChangeModal.vue?vue&type=style&index=0&id=66409650&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-66409650"]])

export default __exports__